import _ from 'underscore';
import DimensionSOVColumns from '../common-columns/dimension-sov-columns';
import { getGridName, getTimeGridRoute } from '../util/dimension-grids';

export function getName() {
  return getGridName(11);
}

export function getRoute(selection) {
  return getTimeGridRoute(selection, 'quarter');
}

export function getColumnsMetadata() {
  return _.defaults(DimensionSOVColumns);
}
